'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @returns {Bluebird Promise}
     */
    rewardCatalog: function rewardCatalog(params) {
        if (!params) {
            throw Error('missing params');
        }

        //for GET's, we don't need to pull query string values out of params passed in
        return this.getApiRequest(this.getUrl().rewardCatalog, params);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @returns {Bluebird Promise}
     */
    rewards: function rewards(params) {
        var extraHeaders = {};
        if (!params) {
            throw Error('missing params');
        }

        if (params.deviceId) {
            extraHeaders.deviceId = params.deviceId;
        }

        if (params.token) {
            extraHeaders.token = params.token;
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().rewards, qs, extraHeaders);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @returns {Bluebird Promise}
     */
    summary: function summary(params) {
        var extraHeaders = {};
        if (!params) {
            throw Error('missing params');
        }

        if (params.deviceId) {
            extraHeaders.deviceId = params.deviceId;
        }

        if (params.token) {
            extraHeaders.token = params.token;
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().summary, qs, extraHeaders);
    },
    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @returns {Bluebird Promise}
     */
    liteSummary: function liteSummary(params) {
        var extraHeaders = {};
        if (!params) {
            throw Error('missing params');
        }

        if (params.deviceId) {
            extraHeaders.deviceId = params.deviceId;
        }

        if (params.token) {
            extraHeaders.token = params.token;
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().currentSummary, qs, extraHeaders);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @param {string} params.rewardId
     * @returns {Bluebird Promise}
     */
    selectReward: function selectReward(params) {
        var extraHeaders = {};
        if (!params) {
            throw Error('missing params');
        }

        if (!params.rewardId) {
            throw Error('missing rewardId');
        }

        if (params.deviceId) {
            extraHeaders.deviceId = params.deviceId;
        }

        if (params.token) {
            extraHeaders.token = params.token;
        }

        if (params.rewardId) {
            extraHeaders.rewardId = params.rewardId;
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().selectReward, qs, extraHeaders);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @param {string} params.siteNum
     * @param {string} params.loyaltyPhoneNum
     * @param {string} params.apiKey
     * @returns {Bluebird Promise}
     */
    preEnrollCSO: function preEnrollCSO(params) {
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().preEnrollCSO, qs, params);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @param {string} params.siteNum
     * @param {string} params.loyaltyPhoneNum
     * @param {string} params.apiKey
     * @returns {Bluebird Promise}
     */
    summaryCSO: function summaryCSO(params) {
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().loyaltySummaryCSO, qs, params);
    },

    /**
     * @param params
     * @param {string} params.siteNum
     * @param {string} params.posItemId
     * @returns {Bluebird Promise}
     */
    salesItemsForReward: function selectReward(params) {
        if (!params) {
            throw Error('missing params');
        }

        if (!params.posItemId) {
            throw Error('missing posItemId');
        }

        if (!params.siteNum) {
            throw Error('missing siteNum');
        }

        //for GET's, we don't need to pull query string values out of params passed in
        return this.getApiRequest(this.getUrl().menuGetRewardSalesItems, params);
    },

    /**
     * @param params
     * @param {string} params.postal
     * @param {string} params.token
     * @returns {Bluebird Promise}
     */
    available: function available(params) {
        if (!params) {
            throw Error('missing params');
        }

        if (!params.postal) {
            throw Error('missing postal code');
        }

        //for GET's, we don't need to pull query string values out of params passed in
        return this.getApiRequest(this.getUrl().available, params);
    },

    /**
     * @param params
     * @param {string} params.token
     * @param {string} params.deviceId
     * @param {string} params.loyaltyPhoneNum
     * @param {string} params.rewardId
     * @param {string} params.postal
     * @returns {Bluebird Promise}
     */
    existingAccountEnroll: function existingAccountEnroll(params) {
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().enroll, qs, params);
    },

    /**
     * @param params
     * @param {string} params.login
     * @param {string} params.deviceId
     * @param {string} params.loyaltyPhoneNum
     * @param {string} params.rewardId
     * @returns {Bluebird Promise}
     */
    pendingAccountEnroll: function pendingAccountEnroll(params) {
        if (params && params.token) {
            delete params.token;
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().pendingEnroll, qs, params);
    },

    /**
     * @param params
     * @param {string} params.token
     * @param {string} params.deviceId
     * @param {string} params.replacementCardNum
     * @returns {Bluebird Promise}
     */
    replaceLoyaltyCard: function replaceLoyaltyCard(params) {
        if (!params) {
            throw Error('missing params');
        }

        if (!params.replacementCardNum) {
            throw Error('missing loyaltyCardNum');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().replaceLoyaltyCard, qs, params);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/loyaltyServiceClient.js
// module id = 775
// module chunks = 0